export default {
    root: {
        class: [
            'relative',

            // Alignment
            'inline-flex',
            'align-bottom',

            // Size
            'w-6',
            'h-6',

            // Misc
            'cursor-pointer',
            'select-none'
        ]
    },
    box: ({props, context}) => ({
        class: [
            // Alignment
            'flex',
            'items-center',
            'justify-center',

            // Size
            'w-6',
            'h-6',

            // Shape
            'rounded-md',
            'border-2',

            // Colors
            {
                'border-stone-200 bg-stone-50 dark:border-stone-700 dark:bg-stone-900': !context.checked && !props.invalid,
                'border-askr-green bg-askr-green': context.checked
            },

            // Invalid State
            {'border-red-500 dark:border-red-400': props.invalid},

            // States
            {
                'peer-hover:border-askr-green': !props.disabled && !context.checked && !props.invalid,
                'peer-hover:bg-askr-green peer-hover:border-askr-green': !props.disabled && context.checked,
                'peer-focus-visible:border-askr-green-500 dark:peer-focus-visible:border-askr-green-400 peer-focus-visible:ring-2 peer-focus-visible:ring-askr-green-400/20 dark:peer-focus-visible:ring-askr-green-300/20': !props.disabled,
                'cursor-default opacity-60': props.disabled
            },

            {'[&>svg]:text-askr-green-contrast [&>svg]:w-[0.875rem] [&>svg]:h-[0.875rem]': context.checked},

            // Transitions
            'transition-colors',
            'duration-200'
        ]
    }),
    input: {
        class: [
            'peer',

            // Size
            'w-full ',
            'h-full',

            // Position
            'absolute',
            'top-0 left-0',
            'z-10',

            // Spacing
            'p-0',
            'm-0',

            // Shape
            'opacity-0',
            'rounded-md',
            'outline-none',
            'border-2 border-stone-200 dark:border-stone-700',

            // Misc
            'appearance-none',
            'cursor-pointer'
        ]
    },
    icon: ({state, context}) => ({
        class: [
            // Font
            'text-base leading-none',

            // Size
            'w-4',
            'h-4',

            // Colors
            {
                'text-white dark:text-stone-900': context.checked,
                'text-askr-green': state.d_indeterminate
            },

            // Transitions
            'transition-all',
            'duration-200'
        ]
    })
};
